var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSouthWest = function SvgSouthWest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "south_west_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#south_west_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 19a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 18v-8q0-.424.287-.712A.97.97 0 0 1 6 9q.424 0 .713.288Q7 9.575 7 10v5.6L17.9 4.7a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L8.4 17H14q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 14 19z"
  }))));
};
export default SvgSouthWest;